import CalendarSourcesAPI from 'dashboard/api/calendarSources';
import { createStore } from 'dashboard/store/storeFactory';

export const useCalendarSourcesStore = createStore({
  name: 'calendarSources',
  type: 'pinia',
  API: CalendarSourcesAPI,
});
